import React from 'react';
import useUser from '@monorepo/auth/hooks/useUser';
import columns from './columns';
import useGetPriceLists from '../../hooks/useGetPriceLists';
import DataCollapseTable from './components/DataCollapseTable';
import {useI18n} from "@monorepo/i18n";

type TDealsListFC = {
  config: {
    pageSize: number;
    defaultFilter: object;
  };
};

const PriceList: FC<TDealsListFC> = ({ config }) => {
  const { pageSize, defaultFilter } = config;
  const { data: user, isLoading: isUserLoading } = useUser();
  const { t } = useI18n();

  // Otherwise, load price lists
  const { isFetching, data, fetchNextPage, hasNextPage, convertDataForGrid } =
    useGetPriceLists({ pageSize, defaultFilter, enabled: !isUserLoading && !user?.isLimited, });

  // If user is still loading, show loader (optional)
  if (isUserLoading) {
    return <div>Loading...</div>;
  }

  // If user has limited access, show "no permission"
  if (user?.isLimited) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: 'gray' }}>
        {t("uitext.no_permission_to_view_page")}
      </div>
    );
  }
  const convertedData = convertDataForGrid(data);

  return (
    <DataCollapseTable
      columns={columns}
      data={convertedData}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage || false}
      isFetching={isFetching}
    />
  );
};

export default PriceList;
